<template>
  <div style="position: relative;">
    <el-form ref="flowAreaWorkList" :model="flowAreaWorkList" label-width="100px" :size="defaultFormItemSize" label-position="right" @submit.native.prevent>
      <filter-box :item-width="350">
        <el-form-item label="工单状态" prop="formFilter.flowStatus">
          <el-select class="filter-item" v-model="flowAreaWorkList.formFilter.flowStatus" :clearable="true"
            placeholder="工单状态">
            <el-option v-for="item in SysFlowWorkOrderStatus.getList()" :key="item.id"
              :label="item.name" :value="item.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="创建日期" prop="formFilter.createTime">
          <date-range class="filter-item" v-model="flowAreaWorkList.formFilter.createTime" :clearable="true" :allowTypes="['day']" align="left"
            range-separator="-" start-placeholder="开始日期" end-placeholder="结束日期"
            format="yyyy-MM-dd" value-format="yyyy-MM-dd HH:mm:ss" />
        </el-form-item>
        <el-form-item label="工单编号" prop="formFilter.workOrderCode">
          <el-input class="filter-item" v-model="flowAreaWorkList.formFilter.workOrderCode"
            :clearable="true" placeholder="工单编号"
          />
        </el-form-item>
        <el-form-item label="创建人" prop="formFilter.createUserName">
          <el-input class="filter-item" v-model="flowAreaWorkList.formFilter.createUserName"
                    :clearable="true" placeholder="创建人名称"
          />
        </el-form-item>
        <el-form-item label="内容" prop="formFilter.queryForm.workContent">
          <el-input class="filter-item" v-model="flowAreaWorkList.formFilter.queryForm.workContent"
                    :clearable="true" placeholder="内容"
          />
        </el-form-item>
        <el-form-item label="流程状态" prop="formFilter.latestApprovalStatus">
          <el-select class="filter-item" v-model="flowAreaWorkList.formFilter.latestApprovalStatus"
                     :clearable="true" filterable
                     placeholder="" :loading="flowAreaWorkList.latestApprovalStatus.impl.loading"
                     @visible-change="flowAreaWorkList.latestApprovalStatus.impl.onVisibleChange"
          >
            <el-option v-for="item in flowAreaWorkList.latestApprovalStatus.impl.dropdownList" :key="item.id"
                       :value="item.id" :label="item.name"
            />
          </el-select>
        </el-form-item>

        <el-button slot="operator" type="default" :plain="true" :size="defaultFormItemSize" @click="onReset">重置</el-button>
        <el-button slot="operator" type="primary" :plain="true" :size="defaultFormItemSize" @click="refreshFlowAreaWorkList(true)">查询</el-button>
        <el-button slot="operator" type="primary" :size="defaultFormItemSize"
                   @click="onStartTaskClick()">
          新建
        </el-button>
      </filter-box>
    </el-form>
    <el-table ref="areaWork"
      :data="areaWorkWidget.dataList"
      :size="defaultFormItemSize"
      :seq-config="{startIndex: ((areaWorkWidget.currentPage - 1) * areaWorkWidget.pageSize)}"
      @sort-change="areaWorkWidget.onSortChange"
      header-cell-class-name="table-header-gray"
    >

      <el-table-column label="序号" header-align="center" align="center" type="index" width="55px"
                       :index="areaWorkWidget.getTableIndex"
      />
      <el-table-column label="工单编号" prop="workOrderCode" />
      <el-table-column label="创建人" prop="userShowName" />

      <el-table-column label="活动内容" prop="masterData.workContent" />
      <el-table-column label="现场图片" min-width="100px">
        <template slot-scope="scope">
          <el-image v-for="item in parseUploadData(scope.row.masterData.siteImages, {id: scope.row.masterData.id, fieldName: 'siteImages', asImage: true})"
            :preview-src-list="getPictureList(scope.row.masterData.siteImages, {id: scope.row.masterData.id, fieldName: 'siteImages', asImage: true})"
            class="table-cell-image" :key="item.url" :src="item.url" fit="fill">
            <div slot="error" class="table-cell-image">
              <i class="el-icon-picture-outline"></i>
            </div>
          </el-image>
        </template>
      </el-table-column>
<!--      <el-table-column label="创建时间" prop="masterData.createTime">-->
<!--        <template slot-scope="scope">-->
<!--          <span>{{formatDateByStatsType(scope.row.masterData.createTime, 'day')}}</span>-->
<!--        </template>-->
<!--      </el-table-column>-->
      <el-table-column label="当前任务" prop="runtimeTaskInfo.taskName" />
      <el-table-column label="流程创建时间" prop="createTime" />
      <el-table-column label="流程状态" prop="latestApprovalStatusDictMap.name" width="100px" />
      <el-table-column label="工单状态" prop="flowStatus"  width="100px">
        <template slot-scope="scope">
          <span>{{SysFlowWorkOrderStatus.getValue(scope.row.flowStatus)}}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="150px" fixed="right">
        <template slot-scope="scope">
          <el-button type="text" :size="defaultFormItemSize"
            v-if="(scope.row.initTaskInfo || {}).taskKey !== (scope.row.runtimeTaskInfo || {}).taskKey"
            @click.stop="onViewTaskClick(scope.row)">
            详情
          </el-button>
          <el-button type="text" :size="defaultFormItemSize"
            v-if="(scope.row.initTaskInfo || {}).taskKey === (scope.row.runtimeTaskInfo || {}).taskKey"
            @click.stop="onHandlerTaskClick(scope.row)">
            办理
          </el-button>
          <el-button type="text" :size="defaultFormItemSize" class="table-btn"
            @click.stop="onRemindClick(scope.row)">
            催办
          </el-button>
          <el-button type="text" :size="defaultFormItemSize" class="table-btn error"
            @click.stop="onCancelTaskClick(scope.row)">
            撤销
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-row type="flex" justify="end" style="margin-top: 10px;">
      <el-pagination
        :total="areaWorkWidget.totalCount"
        :current-page="areaWorkWidget.currentPage"
        :page-size="areaWorkWidget.pageSize"
        :page-sizes="[10, 20, 50, 100]"
        layout="total, prev, pager, next, sizes"
        @current-change="areaWorkWidget.onCurrentPageChange"
        @size-change="areaWorkWidget.onPageSizeChange">
      </el-pagination>
    </el-row>
  </div>
</template>

<script>
import '@/staticDict/flowStaticDict.js';
/* eslint-disable-next-line */
import { DropdownWidget, TableWidget, UploadWidget, ChartWidget } from '@/utils/widget.js';
/* eslint-disable-next-line */
import { uploadMixin, statsDateRangeMixin, cachePageMixin } from '@/core/mixins';
/* eslint-disable-next-line */
import { AreaWorkController, DictionaryController } from '@/api';
/* eslint-disable-next-line */
import { FlowOperationController } from '@/api/flowController.js';

const processDefinitionKey = 'flowAreaWork';
const processDefinitionName = '辖区工作流程';

export default {
  name: 'flowAreaWorkList',
  props: {
  },
  mixins: [uploadMixin, statsDateRangeMixin, cachePageMixin],
  data () {
    return {
      flowAreaWorkList: {
        formFilter: {
          flowStatus: undefined,
          workOrderCode: undefined,
          createTime: [],
          latestApprovalStatus: undefined,
          createUserName: undefined,
          queryForm: {}
        },
        formFilterCopy: {
          flowStatus: undefined,
          workOrderCode: undefined,
          createTime: [],
          latestApprovalStatus: undefined,
          createUserName: undefined,
          queryForm: {}
        },
        latestApprovalStatus: {
          impl: new DropdownWidget(this.loadLatestApprovalStatusDropdownList)
        },
        isInit: false
      },
      areaWorkWidget: new TableWidget(this.loadAreaWorkData, this.loadAreaWorkVerify, true, false)
    }
  },
  methods: {
    onReset () {
      this.$refs.flowAreaWorkList.resetFields();
      this.refreshFlowAreaWorkList(true);
    },
    loadLatestApprovalStatusDropdownList () {
      return new Promise((resolve, reject) => {
        let params = {};
        DictionaryController.dictSysLatestApprovalStatusDict(this, params).then(res => {
          resolve(res.getList());
        }).catch(e => {
          reject(e);
        });
      });
    },
    loadAreaWorkData (params) {
      if (params == null) params = {};
      params = {
        ...params,
        flowWorkOrderDtoFilter: {
          flowStatus: this.flowAreaWorkList.formFilterCopy.flowStatus,
          workOrderCode: this.flowAreaWorkList.formFilterCopy.workOrderCode,
          queryForm: this.flowAreaWorkList.formFilterCopy.queryForm,
          latestApprovalStatus: this.flowAreaWorkList.formFilterCopy.latestApprovalStatus,
          createUserName: this.flowAreaWorkList.formFilterCopy.createUserName,
          createTimeStart: Array.isArray(this.flowAreaWorkList.formFilterCopy.createTime) ? this.flowAreaWorkList.formFilterCopy.createTime[0] : undefined,
          createTimeEnd: Array.isArray(this.flowAreaWorkList.formFilterCopy.createTime) ? this.flowAreaWorkList.formFilterCopy.createTime[1] : undefined
        },
        orderParam: [
          {
            fieldName: 'createTime',
            asc: false
          }
        ]
      }
      return new Promise((resolve, reject) => {
        AreaWorkController.listWorkOrderFlowAreaWork(this, params).then(res => {
          let dataList = res.data.dataList.map(item => {
            item.initTaskInfo = JSON.parse(item.initTaskInfo);
            item.runtimeTaskInfo = Array.isArray(item.runtimeTaskInfoList) ? item.runtimeTaskInfoList[0] : undefined;
            item.masterData = item.masterData || {};
            return item;
          });
          resolve({
            dataList: dataList,
            totalCount: res.data.totalCount
          });
        }).catch(e => {
          reject(e);
        })
      });
    },
    loadAreaWorkVerify () {
      this.flowAreaWorkList.formFilterCopy.flowStatus = this.flowAreaWorkList.formFilter.flowStatus;
      this.flowAreaWorkList.formFilterCopy.workOrderCode = this.flowAreaWorkList.formFilter.workOrderCode;
      this.flowAreaWorkList.formFilterCopy.createTime = this.flowAreaWorkList.formFilter.createTime;
      this.flowAreaWorkList.formFilterCopy.queryForm = this.flowAreaWorkList.formFilter.queryForm;
      this.flowAreaWorkList.formFilterCopy.latestApprovalStatus = this.flowAreaWorkList.formFilter.latestApprovalStatus;
      this.flowAreaWorkList.formFilterCopy.createUserName = this.flowAreaWorkList.formFilter.createUserName;
      return true;
    },
    // 启动流程
    onStartTaskClick () {
      let params = {
        processDefinitionKey: processDefinitionKey
      }

      FlowOperationController.viewInitialTaskInfo(this, params).then(res => {
        if (res.data && res.data.taskType === this.SysFlowTaskType.USER_TASK && res.data.assignedMe) {
          this.$router.push({
            name: res.data.routerName || 'handlerFlowTask',
            query: {
              processDefinitionKey: processDefinitionKey,
              formId: res.data.formId,
              routerName: res.data.routerName,
              readOnly: res.data.readOnly,
              taskName: '启动流程',
              isDraft: true,
              isPreview: false,
              flowEntryName: processDefinitionName,
              variableList: res.data.variableList,
              operationList: (res.data.operationList || []).filter(item => {
                return item.type !== this.SysFlowTaskOperationType.CO_SIGN && item.type !== this.SysFlowTaskOperationType.REVOKE;
              })
            }
          });
        } else {
          FlowOperationController.startOnly(this, {
            processDefinitionKey: processDefinitionKey
          }).then(res => {
            this.$message.success('启动成功！');
          }).catch(e => {});
        }
      }).catch(e => {});
    },
    // 办理流程
    onHandlerTaskClick (row) {
      let taskId = (Array.isArray(row.runtimeTaskInfoList) && row.runtimeTaskInfoList.length > 0) ? row.runtimeTaskInfoList[0].taskId : undefined;
      let params = {
        processInstanceId: row.processInstanceId,
        processDefinitionId: row.processDefinitionId,
        taskId: taskId
      }

      FlowOperationController.viewRuntimeTaskInfo(this, params).then(res => {
        if (res.data) {
          this.$router.push({
            name: res.data.routerName || 'handlerFlowTask',
            query: {
              isRuntime: true,
              isDraft: row.flowStatus === this.SysFlowWorkOrderStatus.DRAFT,
              taskId: taskId,
              processDefinitionKey: processDefinitionKey,
              processInstanceId: row.processInstanceId,
              processDefinitionId: row.processDefinitionId,
              formId: res.data.formId,
              routerName: res.data.routerName,
              readOnly: res.data.readOnly,
              taskName: (row.runtimeInitialTask || {}).taskName,
              flowEntryName: row.processDefinitionName,
              processInstanceInitiator: row.processInstanceInitiator,
              operationList: (res.data.operationList || []).filter(item => {
                return item.type !== this.SysFlowTaskOperationType.CO_SIGN && item.type !== this.SysFlowTaskOperationType.REVOKE;
              }),
              variableList: res.data.variableList
            }
          });
        }
      }).catch(e => {});
    },
    // 查看流程
    onViewTaskClick (row) {
      let params = {
        processInstanceId: row.processInstanceId
      }
      let taskId = (Array.isArray(row.runtimeTaskInfoList) && row.runtimeTaskInfoList.length > 0) ? row.runtimeTaskInfoList[0].taskId : undefined;
      FlowOperationController.viewInitialHistoricTaskInfo(this, params).then(res => {
        if (res.data) {
          this.$router.push({
            name: res.data.routerName || 'handlerFlowTask',
            query: {
              isRuntime: false,
              taskId: taskId,
              processDefinitionKey: row.processDefinitionKey,
              processInstanceId: row.processInstanceId,
              processDefinitionId: row.processDefinitionId,
              routerName: res.data.routerName,
              readOnly: true,
              flowEntryName: row.processDefinitionName,
              processInstanceInitiator: row.processInstanceInitiator
            }
          });
        }
      }).catch(e => {});
    },
    // 催办
    onRemindClick (row) {
      FlowOperationController.remindRuntimeTask(this, {
        workOrderId: row.workOrderId
      }).then(res => {
        this.$message.success('催办成功');
      }).catch(e => {});
    },
    // 撤销流程
    onCancelTaskClick (row) {
      this.$confirm('是否撤销此工单？').then(res => {
        let params = {
          workOrderId: row.workOrderId,
          cancelReason: '主动撤销'
        }

        FlowOperationController.cancelWorkOrder(this, params).then(res => {
          this.$message.success('撤销成功！');
          this.refreshFlowAreaWorkList();
        }).catch(e => {});
      }).catch(e => {});
    },
    // 刷新工单
    refreshFlowAreaWorkList (reloadData = false) {
      if (reloadData) {
        this.areaWorkWidget.refreshTable(true, 1);
      } else {
        this.areaWorkWidget.refreshTable();
      }
      if (!this.flowAreaWorkList.isInit) {
        // 初始化下拉数据
      }
      this.flowAreaWorkList.isInit = true;
    },
    onResume () {
      this.refreshFlowAreaWorkList();
    },
    formInit () {
      this.refreshFlowAreaWorkList();
    }
  },
  mounted () {
    // 初始化页面数据
    this.formInit();
  },
  watch: {
  }
}
</script>

<style>
</style>
